import { render, staticRenderFns } from "./coursesCtaBtns.vue?vue&type=template&id=2444334a&"
import script from "./coursesCtaBtns.vue?vue&type=script&lang=js&"
export * from "./coursesCtaBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports